<template>
  <div>
    <el-dialog title="Leczenie" :visible.sync="dialogVisible" :close-on-click-modal="false">

      <span class="my-label">Wybierz datę</span>
      <el-date-picker v-model="treatment.date" type="date" placeholder="Wybierz datę" :picker-options="pickerOptions" style="width: 100%">
      </el-date-picker>

      <span class="my-label">Wybierz lekarstwo</span>

      <el-select v-model="treatment.drug" filterable value-key="name" placeholder="Wybierz lekarstwo" style="width: 100%">
        <el-option v-for="item in drugs" :key="item.name" :label="item.name" :value="item">
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Anuluj</el-button>
        <el-button type="primary" @click="addTreatment(treatment); dialogVisible = false" :disabled="treatment.drug.name=='' || treatment.date == null">Dodaj</el-button>
      </span>
    </el-dialog>

    <div class="my-btn-panel">
      <el-row :gutter="20">
        <el-col :span="10">
          <div class="grid-content ">
            <el-form>
              <el-form-item label="Aktualnie wybrana">

                <el-select v-model="cow" filterable placeholder="Wybierz krowę" v-on:change="onCowSelected" value-key="number">
                  <el-option v-for="item in cows" :key="item.number" :label="item.number" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>

          </div>
        </el-col>
        <el-col :span="7">
          <div class="grid-content ">
            <el-button type="success" class="my-btn" @click="dialogVisible = true" :disabled="Object.keys(cow).length === 0 && cow.constructor === Object">Dodaj</el-button>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="grid-content">
            <el-button type="danger" class="my-btn" @click="deleteTreatment()" :disabled="currentRow === null">Usuń</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-table :data="cow.treatments" style="overflow: auto;" border stripe highlight-current-row @current-change="handleCurrentChange">
      <el-table-column label="Data leczenia" prop="date" sortable :formatter="formatter">
      </el-table-column>
      <el-table-column label="Nazwa leku" prop="drug.name">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import bus from "@/bus";


export default {
  props: ["cows", "drugs"],
  data: function() {
    return {
      treatmentTableData: [],
      cow: {},
      currentRow: null,
      dialogVisible: false,
      treatment: {
        date: new Date(),
        drug: {
          name: ""
        }
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "Dzisiaj",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "Wczoraj",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  },
  mounted: function() {
    bus.$on(
      "cow-selected",
      function(value) {
        if (value) {
          this.cow = value;
        }
      }.bind(this)
    );
  },
  methods: {
    formatter(row, column) {
      return new Date(row[column.property]).toLocaleDateString(); //toISOString().slice(0, 10);
    },
    handleCurrentChange(value) {
      this.currentRow = value;
    },
    onCowSelected() {
      bus.$emit("cow-selected", this.cow);
    },
    deleteTreatment() {
      if (this.currentRow !== null) {
        this.cow.treatments = this.cow.treatments.filter(
          function(item) {
            return (
              new Date(this.currentRow.date).getTime() !==
              new Date(item.date).getTime()
            );
          }.bind(this)
        );

        bus.$emit("save-cow", this.cow);
      }
    },
    addTreatment(treatment) {
      if (typeof this.cow.treatments == "undefined") {
        this.cow.treatments = [];
      }
      this.cow.treatments.push(treatment);

      treatment.date = treatment.date.toJSON();

      bus.$emit("save-cow", this.cow);

      this.treatment = {
        date: new Date(),
        drug: {
          name: ""
        }
      };
    }
  }
};
</script>

<style>

</style>
